import React from "react";

import { useTheme } from "../../../context/theme";
import { DISABLED_TEXT_OPACITY } from "../../../styles/colors/consts";
import { Box } from "../../layout";
import { InputProps } from "./types";

type Props = InputProps<string> & {
  type: "text" | "email" | "password";
  id: string;
  name?: string;
  error?: boolean;
  dataTest?: string;
};

export default function TextInput(props: Props) {
  const {
    id,
    name,
    error,
    dataTest = "FormInput",
    disabled,
    ...inputProps
  } = props;

  const theme = useTheme();

  return (
    <Box
      disabled={disabled}
      component="input"
      id={id}
      name={name}
      {...inputProps}
      dataTest={dataTest}
      width="100%"
      borderRadius="small"
      borderStyle="solid"
      borderWidth="xxxsmall"
      opacity={disabled ? DISABLED_TEXT_OPACITY : "1"}
      backgroundColor={theme.foreground}
      color={theme["neutral-high-content"]}
      borderColor={
        error ? theme["error-high-content"] : theme["neutral-high-content"]
      }
      focusStyles={{
        borderColor: theme["primary-high-content"],
        outline: "0"
      }}
      placeholderStyles={{
        color: theme["neutral-medium-content"]
      }}
      paddingX="xlarge"
      paddingY="12"
    />
  );
}
